import {IntroContent} from './intro.types';

export const INTRO_CONTENT: IntroContent[] = [
	{
		id: 1,
		background: '/img/intro/intro01.png',
		head: 'Keep track of the set list and earn rewards!',
		desc: 'Songwriters earn royalties through the accurate tracking of what songs are played in a set. Earn reward points and help musicians get paid by tracking the set list for tonight`s show.',
	},
	{
		id: 2,
		background: '/img/intro/intro02.png',
		head: 'Unlock Rewards with SET Tokens',
		desc: 'Earn SetPay (SET) Tokens by keeping track of what songs are performed tonight. SET Tokens unlock artist-related rewards including merchandise, tickets, backstage passes, and digital collectables!',
	},
	{
		id: 3,
		background: '/img/intro/intro03.png',
		head: 'Get Started',
		desc: 'To get started, share your location to find the event you are attending.We use your location to verify that you are attending tonight`s show.',
	},
];
